import React, { createContext, useContext, useEffect, useState } from "react";

export const THEMES = [
  { id: "onyx", name: "Onyx", swatch: "#7889a3" },
  { id: 'grey', name: 'Grey', swatch: '#3b3e44' },
  { id: "venom", name: "Green", swatch: "#10b981" },
];

const ThemeContext = createContext({ theme: "onyx", setTheme: () => {} });

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    if (localStorage.getItem('gv_theme_migration') !== 'onyx-v1') {
      localStorage.setItem('gv_theme_migration', 'onyx-v1'); localStorage.setItem('gv_theme', 'onyx');
      return 'onyx';
    }
    const saved = localStorage.getItem("gv_theme");
    if (saved === 'stake-blue') return 'grey';
    return THEMES.some((t) => t.id === saved) ? saved : "onyx";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("gv_theme", theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
